var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_vm._t("head",function(){return [_vm._v("TableHead Not Properly Used")]})],2)]),_c('tbody',[_vm._t("body",function(){return [_vm._v("TableBody Not Properly Used")]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }